import { memo } from 'react';

import { AvatarProps } from '@types';
import { getFirstLetters } from '@utils/generic';

import theme from '../../../themes/colors';

const Avatar = ({
  className = '',
  name,
  imageUrl,
  bgColor,
  textColor,
  imageId,
  textClassName = '',
  imageClassName = ''
}: AvatarProps) => {
  const bgColorList = [
    theme.cofeeBlue2,
    theme.cofeeOrange2,
    theme.cofeePurple1,
    theme.cofeeGreen1,
    theme.cofeeRed1,
    theme.cofeeYellow1,
    theme.cofeeViolet1
  ];

  const randomColor =
    bgColorList[Math.floor(Math.random() * bgColorList.length)];

  return (
    <div
      className={`flex items-center justify-center rounded-full border border-grey30 font-medium text-content ${className}`}
      style={{
        backgroundColor: imageUrl ? 'white' : bgColor || randomColor
      }}
    >
      {imageUrl ? (
        <img
          data-testid={imageId}
          className={`inline-block size-full rounded-lg object-cover ${imageClassName}`}
          src={imageUrl}
          alt=""
        />
      ) : (
        <div
          className={`text-sm font-medium text-cofeeNeutral10 ${textClassName}`}
          style={{ color: textColor }}
        >
          {getFirstLetters(name)}
        </div>
      )}
    </div>
  );
};

export default memo(Avatar);
